import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function useSeo(title, description) {
  useEffect(() => {
    const full = title ? `${title} | Maison Madison` : "Maison Madison — Considered Fashion, Since 2025";
    document.title = full;
    const desc = description || "Maison Madison — premium, small-batch womenswear and outerwear. Shop the collection online.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
  }, [title, description]);
}
